import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'catalogInfoModal.relatedSkillsHeading': {
    id: 'catalogInfoModal.relatedSkillsHeading',
    defaultMessage: 'Related skills',
    description: 'Heading of related skills section',
  },
  'catalogInfoModal.moreInfoButton': {
    id: 'catalogInfoModal.moreInfoButton',
    defaultMessage: 'View course details',
    description: 'Button text for the more info footer button.',
  },
  'catalogInfoModal.courseDescriptionTitle': {
    id: 'catalogInfoModal.courseDescriptionTitle',
    defaultMessage: 'About this course',
    description: 'Modal course description title',
  },
  'catalogInfoModal.programDescriptionTitle': {
    id: 'catalogInfoModal.programDescriptionTitle',
    defaultMessage: 'About this program',
    description: 'Modal program description title',
  },
  'catalogInfoModal.programMoreInfoButton': {
    id: 'catalogInfoModal.programMoreInfoButton',
    defaultMessage: 'View program details',
    description: 'Button text for the programs more info footer button.',
  },
  'catalogInfoModal.programCourseListingTitle': {
    id: 'catalogInfoModal.programCourseListingTitle',
    defaultMessage: 'Courses in this program',
    description: 'Title text for courses listing section',
  },
  'catalogInfoModal.programLearningItemsHeader': {
    id: 'catalogInfoModal.programLearningItemsHeader',
    defaultMessage: 'What you will learn',
    description: 'Header text for learning items section',
  },
});

export default messages;
